import _DialogTitle from "@material-ui/core/esm/DialogTitle";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import CloseButton from '../../../../ui/close-button';
import CSSClasses from '../../popup-dialog.scss';
const styles = () => ({
  root: {},
  header: {
    fontWeight: 700,
    fontSize: '1.675em'
  }
});
export const Title = withStyles(styles)(props => {
  const {
    children,
    classes,
    onClose,
    showCloseButton,
    titleHeader,
    closeClass,
    titleClasses = {},
    closeStyles
  } = props;
  return /*#__PURE__*/React.createElement(_DialogTitle, {
    classes: _extends(classes, titleClasses),
    disableTypography: true
  }, /*#__PURE__*/React.createElement("h2", {
    className: classnames(classes.header, titleHeader)
  }, children, showCloseButton && /*#__PURE__*/React.createElement(CloseButton, {
    className: classnames(CSSClasses.close, closeClass),
    onClick: onClose,
    styles: closeStyles,
    dataButton: "Close"
  })));
});